<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    beforeCreate:function(){


    },
    mounted:function() {
      //换了路由方式于是不用了
      window.addEventListener('hashchange', function() {
        console.log('hashchange');
        var currentPath = window.location.hash.slice(1); // 获取输入的路由
        if (this.$router.path !== currentPath) {
          this.$router.push(currentPath); // 动态跳转
        }
      }, false);
    }
  }
</script>

<style lang="sass">
  @import "./style/basic"
  @import "./style/common"
</style>



// WEBPACK FOOTER //
// src/App.vue